import { Component, defineComponent } from '@decify/cell-shopify/client';
import './Overlay.scss';
export const overlayName = 'Overlay';
export const overlayTagName = 'cell-component-overlay';
export const overlayClickEvent = 'click';
export class Overlay extends Component {
    constructor() {
        super(overlayName);
        this.handleClick = this.handleClick.bind(this);
    }
    componentDidMount() {
        this.subscribe('click', this.handleClick);
    }
    handleClick() {
        this.publish(overlayClickEvent);
    }
}
defineComponent(overlayTagName, Overlay);
